/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/RadioGroup',['pixi', 'absolute', 'lodash', 'MenuUI/RadioButton'],

	function (PIXI, Absolute, _, RadioButton) {

		var RadioGroup = function (options) {

			var defaultOptions = {
				radioButtons: [],
				letterStyle: {
					font: Absolute.ScreenMetrics.getResScale() * 23 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					tint: 0xffffff,
					align: 'left'
				},
				title: 'fix this',
				action: ''
			};

			this._initRadioGroup(_.extend(defaultOptions, options));
		};

		RadioGroup.constructor = RadioGroup;
		RadioGroup.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		RadioGroup.prototype._initRadioGroup = function (options) {

			PIXI.DisplayObjectContainer.call(this);

			this.options = options;
			this.selectedValue = '';
			this.buttons = {};
			this._height = 0;
			this.controlGroup = [];

			var buttonCount = 0,
				title = new PIXI.Text(this.options.title, this.options.letterStyle);

			this.addChild(title);
			_.each(this.options.radioButtons, function (radioButtonData) {

				if (radioButtonData.visible != false) {
					buttonCount++;

					radioButtonData.action = this.handleAction.bind(this);
					radioButtonData.hoverColor = this.options.hoverColor;

					if (this.options.setting == radioButtonData.value) {
						radioButtonData.selected = true;
					} else {
						radioButtonData.selected = false;
					}

					var radioButton = new RadioButton(radioButtonData);
					radioButton.y = Absolute.Coords.y(0) + buttonCount * Absolute.Coords.y(35);

					this.buttons[radioButtonData.label] = radioButton;
					if (this.options.isGameOption) {
						radioButton.x += Absolute.Coords.x(10);
					}

					this.controlGroup.push(radioButton);
					this.addChild(radioButton);

					this._height = radioButton.y + radioButton.height;
				}
			}, this);

			this._height += Absolute.Coords.x(20);

		};

		RadioGroup.prototype.handleActivate = function (buttonLabel) {
			if (this.buttons.count) {
				for (i = 0; i < this.buttons.count; i++) {
					if (this.buttons[i].selected) {
						this.buttons[i].deselect();
						if (i < this.buttons.count - 1) {
							this.buttons[i + 1].select();
						} else {
							this.buttons[0].select();
						}
						break;
					}
				}
			} else if (this.buttons["buttons.left"] && this.buttons["buttons.right"]) {
				if (this.buttons["buttons.left"]["selected"]===true) {
					this.buttons["buttons.left"].deselect();
					this.buttons["buttons.right"].select();
				} else {
					this.buttons["buttons.right"].deselect();
					this.buttons["buttons.left"].select();
				}
			}
		}

		RadioGroup.prototype.handleAction = function (buttonLabel) {

			var selectedButton = this.buttons[buttonLabel];

			_.each(this.buttons, function (button) {
				button.deselect();
			});

			selectedButton.select();

			this.options.action(this.options.settingPrefix, this.options.settingsKey, selectedButton.value);
		};

		RadioGroup.prototype.updateState = function (setting) {

			this.options.setting = setting;
			_.each(this.buttons, function (button) {
				if (this.options.setting == button.value) {
					button.select();
				} else {
					button.deselect();
				}
			}, this);

		};

		return RadioGroup;

	});

